import React, { ReactNode } from 'react';
import { toast, ToastOptions } from 'react-toastify';

import { NOTIFICATION_TYPES } from 'src/common/constants';

import { Info, Tick } from '../icons';
import { FlexContainer } from '../layout/FlexContainer';

interface toastProps {
    type: string;
    title: string | ReactNode;
    iconColor: string;
    description?: string | ReactNode;
    position?:
        | 'top-right'
        | 'top-center'
        | 'top-left'
        | 'bottom-right'
        | 'bottom-center'
        | 'bottom-left';
}

const renderContent = (
    title: string | ReactNode,
    type: string,
    iconColor: string,
    description?: string | ReactNode,
) => {
    return (
        <>
            <FlexContainer styles={{ gap: 6 }}>
                {type == NOTIFICATION_TYPES.SUCCESS ? (
                    <Tick stroke={iconColor} />
                ) : (
                    <Info fill={iconColor} />
                )}
                {title}
            </FlexContainer>
            {description && <FlexContainer styles={{ marginTop: 8 }}>{description}</FlexContainer>}
        </>
    );
};

const Notify = (props: toastProps) => {
    const options = {
        position: props.position || 'top-right',
        hideProgressBar: true,
        draggable: false,
        pauseOnHover: true,
        closeButton: false,
        icon: false,
        delay: 100,
        style: { marginBottom: 0, width: '308px' },
    };
    toast.dark(renderContent(props.title, props.type, props.iconColor, props.description), {
        ...(options as ToastOptions),
    });
};

export { Notify };
